<template>
    <div>
      <el-card class="box-card">
        <el-table :data="msg" border stripe>
          <el-table-column prop="Jigouname" label="归属机构"></el-table-column>
          <el-table-column prop="Name" label="会员名称"></el-table-column>
          <el-table-column prop="Age" label="会员年龄"></el-table-column>
          <el-table-column prop="d1" label="累计有效佩戴时长"></el-table-column>
          <el-table-column prop="d2" label="累计看近时长"></el-table-column>
          <el-table-column prop="d3" label="累计干预次数"></el-table-column>
        </el-table>

        <div class="title mt20">统计时间</div>
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="75px" class="mt20">
          <el-form-item label="统计时间">
            <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
            <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="info" class="mt20" @click="backDaily">返回</el-button>
            <el-button type="primary" @click="clickexcel" v-if="SubRule_ExcelDailyDetails">导出Excel</el-button>
          </el-form-item>
        </el-form>

        <el-table :data="dataList" border stripe>
          <el-table-column prop="Totaltime" label="佩戴总时长"></el-table-column>
          <el-table-column prop="Youxiaotime" label="有效佩戴时长"></el-table-column>
          <el-table-column prop="Yichangtime" label="异常总时长"></el-table-column>
          <el-table-column prop="Kanjin" label="看近时长"></el-table-column>
          <el-table-column prop="Kanzhong" label="看中时长"></el-table-column>
          <el-table-column prop="Kanyuan" label="看远时长"></el-table-column>
          <el-table-column prop="Ganyunum" label="干预次数"></el-table-column>
          <el-table-column prop="Tingzhinum" label="停止次数"></el-table-column>
          <el-table-column prop="Qiehuannum" label="切换次数"></el-table-column>
          <el-table-column prop="Begingtime" label="起始佩戴时间" width="180px"></el-table-column>
          <el-table-column prop="Endtime" label="停止佩戴时间" width="180px"></el-table-column>
          <el-table-column prop="Tongjitime" label="统计日期"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>

      </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      keywords: {
        begintime: '',
        endtime: ''
      },
      msg: [
        {
          Jigouname: '',
          Name: '',
          Age: '',
          d1: '',
          d2: '',
          d3: ''
        }
      ],
      SubRule_ExcelDailyDetails: false,
      parentdata: null
    }
  },
  mounted () {
    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ExcelDailyDetails', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ExcelDailyDetails = true
      }
    })
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata

      this.apigetDailyDatanum()
      this.apigetDailyDatalist()
      this.msg[0].Jigouname = this.parentdata.params.Jigouname
      this.msg[0].Name = this.parentdata.params.Name
      this.msg[0].Age = this.parentdata.params.Age
    },
    backDaily () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetDailyDatalist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apigetDailyDatanum()
      this.apigetDailyDatalist()
    },
    clickexcel () {
      this.apiExcelDailyDetails()
    },
    apigetDailyDatalist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        pageno: that.selectedPageNo,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDailyDatalist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetDailyDatanum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDailyDatanum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
            that.msg[0].d1 = response.data.Youxiaotime
            that.msg[0].d2 = response.data.Kanjin
            that.msg[0].d3 = response.data.Ganyunum
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelDailyDetails: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelDailyDetails, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
